export default "__VITE_ASSET__DnuhYpcg__"